export default __webpack_public_path__ + "static/media/INFO_icon.28699b02.svg";